/** Largest value encodable by a protobuf `int64` field. */
export const PROTOBUF_INT64_MAX = 9_223_372_036_854_775_807n;

/** Largest value encodable by a protobuf `int32` field. */
export const PROTOBUF_INT32_MAX = 2_147_483_647n;

/** Largest value encodable by a protobuf `uint32` field. */
export const PROTOBUF_UINT32_MAX = 4_294_967_295;
